import classNames from 'classnames/bind';
import { SeatOptionContext } from 'common/searchBox';
import {
  getPassengerDesc,
  getSeatDesc,
  useSearchParamsContext,
} from 'contexts/searchParams';
import { useContext } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  clickCodePrefix: string;
}

export default function Passenger({ className, clickCodePrefix }: IProps) {
  const toggleSeatOption = useContext(SeatOptionContext);
  const {
    searchParams: { passengers, seatClass },
    isDomestic,
  } = useSearchParamsContext();

  return (
    <button
      type="button"
      className={cx(className, 'Passenger')}
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.passeat`}
      onClick={() => toggleSeatOption(prev => !prev)}
    >
      {getPassengerDesc(passengers)}, {getSeatDesc(isDomestic, seatClass)}
    </button>
  );
}
